import { render, staticRenderFns } from "./rugby.vue?vue&type=template&id=226eee34&scoped=true"
import script from "./rugby.vue?vue&type=script&lang=js"
export * from "./rugby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226eee34",
  null
  
)

export default component.exports